/**
 * Defines the watchers related to User Entitled Apps feature.
 * These watchers will be imported in store/RootSaga.js
 */

import { takeLatest, all } from 'redux-saga/effects';
import * as types from 'constants/ActionTypes';
import {
  fetchUserEntitledAppsSaga, updateUserOnboardStatusSaga,
} from './UserEntitledApps.saga';

export default function* watchers() {
  yield all([
    yield takeLatest(types.FETCH_USER_ENTITLED_APPS, fetchUserEntitledAppsSaga),
    yield takeLatest(types.UPDATE_USER_ONBOARD_STATUS, updateUserOnboardStatusSaga),
  ]);
}
